import { render, staticRenderFns } from "./MerhcantHistoryStatusHeader.vue?vue&type=template&id=0f3cd620&scoped=true&"
import script from "./MerhcantHistoryStatusHeader.vue?vue&type=script&lang=js&"
export * from "./MerhcantHistoryStatusHeader.vue?vue&type=script&lang=js&"
import style0 from "./MerhcantHistoryStatusHeader.vue?vue&type=style&index=0&id=0f3cd620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3cd620",
  null
  
)

export default component.exports